const init = function () {

  if ( typeof gsap === 'undefined' ) return;

  gsap.registerPlugin(ScrollTrigger)

  gsap.utils.toArray(".js-parallax-item").forEach( (el, i) => {

    const parent = el.closest('.acf-block-page-section')

    let speedModifier = 400
    let distanceModifier = 0

    ScrollTrigger.matchMedia({
      "(min-width: 740px)": function() {
        distanceModifier = 800
      }, 
      "(max-width: 739px)": function() {
        distanceModifier = 1000
      }
    });

    if ( el.nodeName.toLowerCase() === "svg" ) {
      distanceModifier = 100
    }

    const options = {
      ease: 'none',
      scrollTrigger: {
        trigger: parent,
        start: 'top+='+distanceModifier+'px bottom',
        scrub: 1
      }
    }

    if ( el.hasAttribute('data-speed') ) {
      options.y = ( i, el ) => {
        return ( 1 - parseFloat(el.getAttribute('data-speed')) ) * speedModifier
      }
    }

    gsap.to( el, options )

  })

}


const api = {
  init: init
}

export default api